<template>
    <div>
        <div style="max-width: 400px;margin: 0 auto">
            <q-list bordered>
                <q-item>
                    <q-item-section class="col-4">
                        <q-item-label class="text-grey-7 text-weight-bolder">{{$t('transfers.our_bank_account')}}:</q-item-label>
                    </q-item-section>

                    <q-item-section class="text-right text-weight-bolder">
                        <q-item-label>
                            {{ info.our_bank_account }}
                        </q-item-label>
                    </q-item-section>
                    <q-item-section side>
                        <q-btn round
                               flat
                               size="sm"
                               icon="far fa-copy"
                               color="input-color"
                               @success="copied('Bank account copied!')"
                               v-clipboard="info.our_bank_account"
                        />
                    </q-item-section>
                </q-item> <!-- Our Bank Account -->

                <q-item>
                    <q-item-section class="col-4">
                        <q-item-label class="text-grey-7 text-weight-bolder">Account holder:</q-item-label>
                    </q-item-section>

                    <q-item-section class="text-right text-weight-bolder">
                        <q-item-label>
                            {{ holder }}
                        </q-item-label>
                    </q-item-section>
                    <q-item-section side>
                        <q-btn round
                               flat
                               size="sm"
                               icon="far fa-copy"
                               color="input-color"
                               @success="copied('Account holder copied!')"
                               v-clipboard="holder"
                        />
                    </q-item-section>
                </q-item> <!-- Account Holder -->

                <q-item>
                    <q-item-section class="col-5">
                        <q-item-label class="text-grey-7 text-weight-bolder">Amount:</q-item-label>
                    </q-item-section>

                    <q-item-section class="text-right text-weight-bolder">
                        <q-item-label>
                            <currency-format :value="info.amount"
                                             hide-zero-decimal
                                             hide-white-spaces
                                             class="inline-block"
                            />
                            NZD
                        </q-item-label>
                    </q-item-section>
                    <q-item-section side>
                        <q-btn round
                               flat
                               size="sm"
                               icon="far fa-copy"
                               color="input-color"
                               @success="copied('Amount copied!')"
                               v-clipboard="info.amount"
                        />
                    </q-item-section>
                </q-item> <!-- Amount -->

                <q-item>
                    <q-item-section class="col-5">
                        <q-item-label class="text-grey-7 text-weight-bolder">Reference:</q-item-label>
                    </q-item-section>

                    <q-item-section class="text-right text-weight-bolder">
                        <q-item-label>
                            {{ info.reference }}
                        </q-item-label>
                    </q-item-section>
                    <q-item-section side>
                        <q-btn round
                               flat
                               size="sm"
                               icon="far fa-copy"
                               color="input-color"
                               @success="copied('Reference copied!')"
                               v-clipboard="info.reference"
                        />
                    </q-item-section>
                </q-item> <!-- Reference -->

                <q-item>
                    <q-item-section class="col-5">
                        <q-item-label class="text-grey-7 text-weight-bolder">Particulars:</q-item-label>
                    </q-item-section>

                    <q-item-section class="text-right text-weight-bolder">
                        <q-item-label>
                            {{ info.particulars }}
                        </q-item-label>
                    </q-item-section>
                    <q-item-section side>
                        <q-btn round
                               flat
                               size="sm"
                               icon="far fa-copy"
                               color="input-color"
                               @success="copied('Particulars copied!')"
                               v-clipboard="info.particulars"
                        />
                    </q-item-section>
                </q-item> <!-- Particulars -->
            </q-list>
        </div>
        <div class="row q-pt-lg" v-if="info.type === 'asap'">
            <div class="text-bold text-italic">You chose ASAP Transfer Time. Remember to send us the NZD transaction
                details. (<a
                    href="https://help.anz.co.nz/app/answers/detail/a_id/960/~/share-transaction-details---gomoney">View
                    ANZ Guide</a>)</div>
            <ul>
                <li><b>Email</b>: <a href="mailto:support@rebit.co.nz">support@rebit.co.nz</a></li>
                <li><b>Text</b>: +64 22 124 8180</li>
                <li>
                    <q-icon name="fa fa-comment" color="purple"/>
                    Chat options, in the corner of this page.
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: "PaymentInfo",
    props: {
        info: {
            type:Object,
            required: true
        },
    },
    computed: {},
    data() {
        return {
            holder: 'Rebit Limited'
        }
    },
    methods: {
        copied(message) {
            this.$q.notify({
                message: message,
                position: 'top'
            })
        },
    },
    created() {

    },
    mounted() {

    },
    components: {},
}
</script>
<style>

</style>
